var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('confirm-dialog',{ref:"confirmDialog"}),_c('v-btn',_vm._b({on:{"click":function($event){return _vm.closeIncident()}}},'v-btn',_vm.$attrs,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }